import React from "react";
import { BodyContainer } from "./styles";
import { Route, Switch } from "react-router-dom";
import { appBasePath } from "../../config/paths";
import Home from "../pages/Home";
import App from "../pages/App";

function Body(props) {
  return <BodyContainer>
    <Switch>
      <Route path={appBasePath+"app"} component={App}/>
      <Route path={appBasePath} component={Home}/>
    </Switch>
  </BodyContainer>;
}
export default Body;